import { Component, Input } from '@angular/core';
import { WindowService } from '@cigna/shared/angular/core/window-util';

@Component({
  selector: 'cigna-evernorth-unavailable',
  templateUrl: './unavailable.component.html',
  styleUrls: ['./unavailable.component.scss'],
})
export class UnavailableComponent {
  constructor(private window: WindowService) {}

  @Input() shouldShowRefreshBtn = true;

  refreshBrowser() {
    this.window.location.reload();
  }
}
